import { Button } from '@talentmesh/ui/components/button';
import { Spinner } from '@talentmesh/ui/components/spinner';
import { MouseEventHandler } from 'react';
import { ImageCropContextProps } from './ImageCropContext';
import { ImageCropStrings } from './ImageCropUtils';

export interface ImageCropDialogActionsProps
    extends Pick<ImageCropStrings, 'uploadButtonText'>, Pick<ImageCropContextProps, 'processing'> {
    onUpload: MouseEventHandler<HTMLButtonElement>;
}

export const ImageCropDialogActions = ({ onUpload, processing, uploadButtonText }: ImageCropDialogActionsProps) => {
    return (
        <div className="mt-6 flex flex-row justify-end">
            <Button type="button" size="lg" data-cy="ImageCropUploadButton" disabled={processing} onClick={onUpload}>
                {processing && <Spinner className="mr-2 size-4" />}
                {uploadButtonText}
            </Button>
        </div>
    );
};
